<template>
	<div class="views"><iframe style="width: 100%;height: 100%;" src="http://www.hngtsd.net:8096/#/"></iframe></div>
</template>

<script>
import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {};
	},
	mounted() {},
	created() {
		AppOptions.appEmpty = true;
	},
	beforeDestroy() {},
	beforeRouteLeave(to, from, next) {
		AppOptions.appEmpty = false;
		next();
	}
};
</script>

<style scoped>
.views {
	width: 100%;
	height: 100vh;
}
</style>
